var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"danger","size":"mini","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeCategory(_vm.id)}}},[_vm._v("删除")])
}
var staticRenderFns = []

export { render, staticRenderFns }